import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';

import { ButtonPurpose } from './button-purpose';
import { ButtonType } from './button-type';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ButtonComponent {
  @Input() buttonText = '';
  @Input() enableLight = false;
  @Input() type: ButtonType | `${ButtonType}` = ButtonType.Button;
  @Input() disabled = false;
  @Input() purpose: ButtonPurpose | `${ButtonPurpose}` = ButtonPurpose.Primary;
  @Input() ariaExpanded: boolean | null = null;
  @Input() ariaHaspopup: boolean | string | null = null;
  @ViewChild('button') buttonRef: ElementRef<HTMLButtonElement>;

  @HostBinding('class.btn')
  btnClass = true;

  focus() {
    this.buttonRef?.nativeElement?.focus();
  }
}
